<ces-floating-bar>
  <ces-button-tertiary
    [label]="cancelLabel"
    [disabled]="cancelDisabled"
    [size]="buttonSize"
    [icon]="cancelIcon"
    (onClick)="onDiscard()" />
  @if (secondaryLabel) {
    <ces-button-secondary
      [label]="secondaryLabel"
      [disabled]="secondaryDisabled"
      [size]="buttonSize"
      [icon]="secondaryIcon"
      (onClick)="onSecondary()" />
  }
  <ces-button
    [label]="validateLabel"
    [disabled]="validateDisabled"
    [size]="buttonSize"
    [icon]="validateIcon"
    (onClick)="onValidate()" />
</ces-floating-bar>
